import { useEffect } from 'react';

import { useLocation } from 'react-router';

export function ScreenTitle({ title = 'ELVA Golf' }) {
    const location = useLocation();

    useEffect(() => {
        document.title = title;
    }, [location, title]);

    return null;
}
